import { render, staticRenderFns } from "./ImportLanguageModal.vue?vue&type=template&id=5d994dce&scoped=true&"
import script from "./ImportLanguageModal.vue?vue&type=script&lang=js&"
export * from "./ImportLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d994dce",
  null
  
)

export default component.exports